import script from "./MyData.vue?vue&type=script&setup=true&lang=js"
export * from "./MyData.vue?vue&type=script&setup=true&lang=js"

import "./MyData.vue?vue&type=style&index=0&id=461e979e&lang=css"

const __exports__ = script;

export default __exports__